import { useCssVariable } from "./use-css-variable";

export function useThemeIconColors() {
  return {
    primary: useCssVariable("--primary"),
    muted: useCssVariable("--muted-foreground"),
    success: useCssVariable("--success"),
    destructive: useCssVariable("--destructive"),
  };
}
